/**
 * Do not edit directly!
 * Read more: https://ink.carta.com/contributing/css-styleguide/#tokens
 */

export const iconTokens = {
  SizeXxs: '10',
  SizeXs: '11',
  SizeSm: '12',
  SizeMed: '14',
  SizeLg: '16',
  SizeXl: '19',
  SizeXxl: '22',
} as const;
